
import { Gavel, FileSearch } from "lucide-react";
import { FeaturePageLayout } from "@/components/layout/FeaturePageLayout";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

const LegalAssistance = () => {
  const { t } = useTranslation("platform");
  
  return (
    <FeaturePageLayout
      title={t("legalAssistance.title")}
      subtitle={t("legalAssistance.subtitle")}
      description={t("legalAssistance.description")}
      icon={<Gavel className="h-6 w-6" />}
      bgColor="bg-gradient-to-r from-primary/90 via-purple-600/90 to-primary/90"
    >
      {/* Content section similar to DataIntegration */}
      <section className="mb-20">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold mb-4">{t("legalAssistance.howWorks")}</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            {t("legalAssistance.howWorksDescription")}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-12">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
            className="bg-gray-50 p-8 rounded-lg"
          >
            <h3 className="text-xl font-semibold mb-4 flex items-center">
              <FileSearch className="h-5 w-5 mr-2 text-primary" />
              {t("legalAssistance.continuousMonitoring")}
            </h3>
            <p className="text-gray-600 mb-4">
              {t("legalAssistance.continuousMonitoringDescription")}
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
            className="bg-gray-50 p-8 rounded-lg"
          >
            <h3 className="text-xl font-semibold mb-4 flex items-center">
              <Gavel className="h-5 w-5 mr-2 text-primary" />
              {t("legalAssistance.smartProcessing")}
            </h3>
            <p className="text-gray-600 mb-4">
              {t("legalAssistance.smartProcessingDescription")}
            </p>
          </motion.div>
        </div>
      </section>
    </FeaturePageLayout>
  );
};

export default LegalAssistance;
